import * as React from 'react'

class StepIntro extends React.Component {
  public render() {
    return (
      <div className="Row Row--mw500">
        <p>
          Vous souhaitez faire le point sur votre consommation d’alcool et les risques pour votre
          santé ? Prenez <em>2 minutes</em> pour répondre anonymement à quelques questions et
          obtenez <em>un bilan personnalisé.</em>
        </p>
      </div>
    )
  }
}

export default StepIntro



// WEBPACK FOOTER //
// ./src/components/StepIntro/StepIntro.tsx